export const HOME = {
  emergentLink: "home-emergent-link",
};

export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginForgot: "login-forgot-link",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerName: "register-name-input",
  registerSubmit: "register-submit-btn",
  mfaCode: "mfa-code-input",
  mfaVerify: "mfa-verify-btn",
  mfaEnable: "mfa-enable-btn",
  mfaDisable: "mfa-disable-btn",
  logout: "logout-btn",
  forgotEmail: "forgot-email-input",
  forgotSubmit: "forgot-submit-btn",
  resetPassword: "reset-password-input",
  resetConfirm: "reset-password-confirm-input",
  resetSubmit: "reset-submit-btn",
};

export const NAV = {
  themeToggle: "theme-toggle-btn",
  notificationsBtn: "notifications-btn",
  toDashboard: "nav-dashboard",
  toRooms: "nav-rooms",
  toUsers: "nav-users",
  toSettings: "nav-settings",
};

export const ROOM = {
  createBtn: "room-create-btn",
  createSubmit: "room-create-submit",
  nameInput: "room-name-input",
  descInput: "room-description-input",
  watermarkInput: "room-watermark-input",
  openCard: "room-open-card",
  tabDocs: "room-tab-documents",
  tabMembers: "room-tab-members",
  tabQA: "room-tab-qa",
  tabAnalytics: "room-tab-analytics",
  tabPerms: "room-tab-permissions",
  tabSettings: "room-tab-settings",
};

export const DOC = {
  uploadBtn: "doc-upload-btn",
  uploadInput: "doc-upload-input",
  folderBtn: "doc-folder-btn",
  folderName: "doc-folder-name",
  folderSubmit: "doc-folder-submit",
  row: "doc-row",
  viewBtn: "doc-view-btn",
  downloadPdfBtn: "doc-download-pdf",
  downloadEncBtn: "doc-download-encrypted",
  downloadOrigBtn: "doc-download-original",
  deleteBtn: "doc-delete-btn",
};

export const MEMBER = {
  inviteBtn: "member-invite-btn",
  inviteEmail: "member-invite-email",
  inviteGroup: "member-invite-group",
  inviteRole: "member-invite-role",
  inviteSubmit: "member-invite-submit",
  inviteTemplate: "member-invite-template",
  removeBtn: "member-remove-btn",
};

export const QA = {
  newQuestion: "qa-new-question",
  submitQuestion: "qa-submit-question",
  answerInput: "qa-answer-input",
  submitAnswer: "qa-submit-answer",
};

export const PERM = {
  cell: "perm-cell",
  saveBtn: "perm-save-btn",
};

export const TPL = {
  applyBtn: "tpl-apply-btn",
  applyOpen: "tpl-apply-open",
  applyMember: "tpl-apply-member",
  applyTemplate: "tpl-apply-template",
  applySubmit: "tpl-apply-submit",
};

export const CHK = {
  tab: "room-tab-checklist",
  seedBtn: "chk-seed-btn",
  addBtn: "chk-add-btn",
  itemRow: "chk-item-row",
  statusBtn: "chk-status-btn",
  deleteBtn: "chk-delete-btn",
  newCategory: "chk-new-category",
  newName: "chk-new-name",
  newSubmit: "chk-new-submit",
};

export const BULK = {
  dropzone: "bulk-dropzone",
  fileInput: "bulk-file-input",
  folderInput: "bulk-folder-input",
  startBtn: "bulk-start-btn",
};
